import { Container, injectable } from 'inversify'
import 'reflect-metadata'

import { watch } from 'vue';


import MyApolloClient from '../../../../common/infrastructure/funciones/HelperApolloClient';

import { UPDATE, ADD, GRANTACCESS } from './mutation/objectGroupMutation';
import { IapObjectGroup } from '../domain/iapObjectGroup';
import HelperUtils from '../../../../common/infrastructure/funciones/HelperUtils';
import { debug } from 'console';
import ApolloConst from '../../../../common/domain/constantes/Apollo/ApolloConst';
import { IObjectGroupRepository } from '../domain/IObjectGroupRepository';




@injectable()
export class ObjectGroupApolloClientRepository implements IObjectGroupRepository {
  private apolloClient : MyApolloClient
  private apolloClientId: string
  constructor (apolloInstance: MyApolloClient, _apolloClientId = ApolloConst.DEFAULT) {
    this.apolloClient = apolloInstance
    this.apolloClientId = _apolloClientId
  }
  

  async update (dataInput: IapObjectGroup): (Promise<boolean>) {
    return new Promise<boolean>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(UPDATE,{data:dataInput}, this.apolloClientId)    

      watch(result, (value: any) => {
        
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.menuDirectiveMutation)
        }
        catch(e) {
          reject()
        }
      });

    });
  }

  async add (dataInput: IapObjectGroup): (Promise<boolean>) {
    return new Promise<boolean>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(ADD,{data:dataInput}, this.apolloClientId)    

      watch(result, (value: any) => {
        
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.menuDirectiveMutation)
        }
        catch(e) {
          reject()
        }
      });

    });
  }

  async getAll (maxregs: number | undefined): (Promise<IapObjectGroup[]>) {
    return new Promise<IapObjectGroup[]>(async (resolve, reject) => {
      /*const result = apolloClient.executeQuery(GET_ALL_COMPONENTS, { maxregs: maxregs }, this.apolloClientId)
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.menuDirectiveQuery.getAll)
        }
        catch(e) {
          reject()
        }
      });*/
    });
  }

  async getById (id: number): (Promise<IapObjectGroup>) {
    return new Promise<IapObjectGroup>(async (resolve, reject) => {
      /*const result = apolloClient.executeQuery(GET_COMPONENT_BY_ID, { id: id }, this.apolloClientId)
      
      watch(result, (value: any) => {
        try {
          HelperUtils.handleDatesApollo(value) 
          resolve(value.menuDirectiveQuery.getById)
        }
        catch(e) {
          reject()
        }
      });*/
    });
  }

  async grantAccessToObjectGroup (objectId: number, objectGroup: IapObjectGroup, objectType: string, applicationId: number, applicationVersion: number): (Promise<Boolean>) {
    return new Promise<Boolean>(async (resolve, reject) => {
      const result = this.apolloClient.executeQuery(GRANTACCESS,
        { objectId: objectId, objectGroup: objectGroup, objectType: objectType, applicationId: applicationId, applicationVersion: applicationVersion }, this.apolloClientId)
      
      watch(result, (value: any) => {
        try {
          //HelperUtils.handleDatesApollo(value) 
          resolve(value)
        }
        catch(e) {
          reject()
        }
      });
    });
  }
}


